import type { Action, PayloadAction } from '@reduxjs/toolkit';

export type SettingsState = {
  refresh: Record<string, never>;
  isLoading: boolean;
  isSubmitting: boolean;
  settings: Settings | null;
};

export enum SettingsActionTypes {
  INIT = 'settings/init',
  REFRESH = 'settings/refresh',
  LOADING = 'settings/set/isLoading',
  SUBMITTING = 'settings/set/isSubmitting',
  NAVIGATING = 'settings/set/isNavigating',
  SET_SETTINGS = 'settings/set/settings',
}

export type SettingsAction =
  | Action<SettingsActionTypes.INIT>
  | Action<SettingsActionTypes.REFRESH>
  | PayloadAction<boolean, SettingsActionTypes.LOADING>
  | PayloadAction<boolean, SettingsActionTypes.SUBMITTING>
  | PayloadAction<boolean, SettingsActionTypes.NAVIGATING>
  | PayloadAction<Settings | null, SettingsActionTypes.SET_SETTINGS>;

// 設定更新
export type SettingsUpdateSubmitData = {
  is_public: boolean;
};

/** @summary 設定情報取得API戻り値を格納する型 */
export type Settings = {
  /** 非公開状況 */
  isPublic: boolean;
};

export type APISettings = {
  readonly is_public: boolean;
};

export type APIGetSettingsResponse = {
  result: APISettings;
};

export type APIUpdateSettings = {
  readonly is_public: boolean;
};

export type APIUpdateSettingsRequest = APIUpdateSettings;